import { searchFilterRegexp } from "../constants/search-filter-regexp";
import { getFilterIndex } from "./get-filter-index";
export var getSearchFilterIndex = function (filters) {
    return getFilterIndex(filters, searchFilterRegexp);
};
